import { actionCreatorFactory } from 'typescript-fsa';
import { ORDER_PARTS } from '@app/react/const/variables';

const actionCreator = actionCreatorFactory();

export interface IPageOpenDetection {
    open: boolean;
}

export const pageOpenAction = actionCreator<{
    partsName: typeof ORDER_PARTS[number] | null }>('pageopen');

export const shaftPageOpenDetectionAction = actionCreator<IPageOpenDetection>(
    'shaftPageOpenDetectionAction',
);
export const featherPageOpenDetectionAction = actionCreator<IPageOpenDetection>(
    'featherPageOpenDetectionAction',
);
export const threadPageOpenDetectionAction = actionCreator<IPageOpenDetection>(
    'threadPageOpenDetectionAction',
);
export const kebikiPageOpenDetectionAction = actionCreator<IPageOpenDetection>(
    'kebikiPageOpenDetectionAction',
);
export const nockPageOpenDetectionAction = actionCreator<IPageOpenDetection>(
    'nockPageOpenDetectionAction',
);
export const arrowheadPageOpenDetectionAction = actionCreator<IPageOpenDetection>(
    'arrowheadPageOpenDetectionAction',
);
export const arrowlengthPageOpenDetectionAction = actionCreator<IPageOpenDetection>(
    'arrowlengthPageOpenDetectionAction',
);
export const unitPageOpenDetectionAction = actionCreator<IPageOpenDetection>(
    'unitPageOpenDetectionAction',
);
export const arrowinsertPageOpenDetectionAction = actionCreator<IPageOpenDetection>(
    'arrowinsertPageOpenDetectionAction',
);
export const twinePageOpenDetectionAction = actionCreator<IPageOpenDetection>(
    'twinePageOpenDetectionAction',
);
export const lamePageOpenDetectionAction = actionCreator<IPageOpenDetection>(
    'lamePageOpenDetectionAction',
);
export const carvingPageOpenDetectionAction = actionCreator<IPageOpenDetection>(
    'carvingPageOpenDetectionAction',
);
export const familycrestPageOpenDetectionAction = actionCreator<IPageOpenDetection>(
    'familycrestPageOpenDetectionAction',
);
export const typezeroPageOpenDetectionAction = actionCreator<IPageOpenDetection>(
    'typezeroPageOpenDetectionAction',
);
export const decorationPageOpenDetectionAction = actionCreator<IPageOpenDetection>(
    'decorationPageOpenDetectionAction',
);
export const featherinsidePageOpenDetectionAction = actionCreator<IPageOpenDetection>(
    'featherinsidePageOpenDetectionAction',
);
